import { Box, Grid } from "@mui/material";
import DefaultBtnModel from "components/defaultBtnModel/DefaultBtnModel";
import AppSnackbar from "components/snakbar";
import { SnackbarState } from "models/user-models";
import {
  EITModal,
  ExaminationModal,
  LocationModal,
  LocationWithScrollDowns,
  WizardOptionModal,
  WizardProps,
  defaultBtnObj,
  wizardDisplayModal,
  wizardIterationModal,
} from "models/wizard/wizard-modals";
import React, { useEffect, useState } from "react";
import { MdAlarm, MdRefresh, MdFormatSize } from "react-icons/md";
import { LiaSearchLocationSolid } from "react-icons/lia";
import Select from "react-select";
import SelectLocationModal from "../locations/SelectLocationModal";
import { getSystemPriority } from "utils/priority-utils";
import VoiceNoteGeneration from "./VoiceNoteGeneration";
import { VoiceNoteReport } from "api/ai";

export interface ScrollDown {
  description: string;
  priority: number;
}

const WizardManagement: React.FC<WizardProps> = ({
  updateReportList,
  setIsCompleted,
  data,
  setData,
  page,
  setPage,

  systemList,

  complaintList,
  complaintRemark,
  setComplaintRemark,
  duration,
  setDuration,
  durationType,
  setDurationType,

  otherSymptomList,
  otherSymptomRemark,
  setOtherSymptomRemark,
  otherSymptomDuration,
  setOtherSymptomDuration,
  otherSymptomDurationType,
  setOtherSymptomDurationType,

  historyList,
  historyDuration,
  setHistoryDuration,
  historyDurationType,
  setHistoryDurationType,
  historyRemark,
  setHistoryRemark,

  examinationList,
  examinationRemark,
  setExaminationRemark,

  impressionList,
  impressionRemark,
  setImpressionRemark,

  locationList,

  treatmentList,
  treatmentRemark,
  setTreatmentRemark,

  resetSelectedOptions,
  resetTrigger,
  setResetTrigger,

  setComplaintLocation,
  complaintLocation,
  setOtherSymptomLocation,
  otherSymptomLocation,
  setExaminationLocation,
  examinationLocation,
  setImpressionLocation,
  impressionLocation,
  onVoiceReportGenerated,
  onVoiceModeChange,
}) => {
  const [voiceMode, setVoiceMode] = useState(false);
  const [compId, setCompId] = useState<string>("");
  const [subComp, setSubComp] = useState<ScrollDown[]>([]);
  const [selectedSubComp, setSelectedSubComp] = useState<wizardDisplayModal[]>(
    []
  );

  const [otherSymptomId, setOtherSymptomId] = useState<string>("");
  const [subOtherSymptom, setSubOtherSymptom] = useState<ScrollDown[]>([]);
  const [selectedSubOtherSymptom, setSelectedSubOtherSymptom] = useState<
    wizardDisplayModal[]
  >([]);
  const [otherSymptomDurationDialog, setOtherSymptomDurationDialog] =
    useState<boolean>(false);
  const [otherSymptomLocationDialog, setOtherSymptomLocationDialog] =
    useState<boolean>(false);
  const [examinationLocationDialog, setExaminationLocationDialog] =
    useState<boolean>(false);
  const [impressionLocationDialog, setImpressionLocationDialog] =
    useState<boolean>(false);

  const [historyId, setHistoryId] = useState<string>("");
  const [subHistory, setSubHistory] = useState<ScrollDown[]>([]);
  const [selectedSubHistory, setSelectedSubHistory] = useState<
    wizardDisplayModal[]
  >([]);
  const [historyDurationDialog, setHistoryDurationDialog] =
    useState<boolean>(false);

  const [examId, setExamId] = useState<string>("");
  const [subExams, setSubExams] = useState<ScrollDown[]>([]);
  const [selectedSubExams, setSelectedSubExams] = useState<
    wizardDisplayModal[]
  >([]);

  const [impId, setImpId] = useState<string>("");
  const [subImp, setSubImp] = useState<ScrollDown[]>([]);
  const [selectedSubImp, setSelectedSubImp] = useState<wizardDisplayModal[]>(
    []
  );

  const [treatPlanId, setTreatPlanId] = useState<string>("");
  const [subTreatPlan, setSubTreatPlan] = useState<ScrollDown[]>([]);
  const [selectedSubTreatPlan, setSelectedSubTreatPlan] = useState<
    wizardDisplayModal[]
  >([]);

  const [displayObj, setDisplayObj] = useState({
    optionNumber: 1,
    heading: "Systems:",
    subHeading: "",
  });
  const [displayList, setDisplayList] = useState<wizardDisplayModal[]>([]);

  const [currentIteration] = useState<wizardIterationModal>({
    iterationName: "Systems",
    iterationState: true,
  });
  const [durationDialog, setDurationDialog] = useState<boolean>(false);
  const [locationDialog, setLocationDialog] = useState<boolean>(false);

  const [selectedButton, setSelectedButton] = useState(null);
  const [selectedOptionList, setSelectedOptionList] = useState<
    WizardOptionModal[]
  >([]);

  const [selectedValue, setSelectedValue] = useState({
    system: "",
    complaint: "",
    otherSymptom: "",
    history: "",
    examination: "",
    impression: "",
    treatmentPlans: "",
  });

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: "info",
  });
  const [isSorted, setIsSorted] = useState(false);
  const [isSortedByP, setIsSortedByP] = useState(true);

  const voiceCatalog = {
    system: systemList || [],
    complaints: complaintList || [],
    otherSymptoms: otherSymptomList || [],
    history: historyList || [],
    examinations: examinationList || [],
    impressions: impressionList || [],
    treatment_plans: treatmentList || [],
  };

  const enterVoiceMode = () => {
    setVoiceMode(true);
    onVoiceModeChange?.(true);
  };

  const leaveVoiceMode = () => {
    setVoiceMode(false);
    onVoiceModeChange?.(false);
  };

  const [textSize, setTextSize] = useState<"small" | "medium" | "large">(() => {
    const saved = localStorage.getItem("wizardTextSize");
    return saved === "small" || saved === "medium" || saved === "large"
      ? saved
      : "medium";
  });

  const handleTextSizeChange = (size: "small" | "medium" | "large") => {
    setTextSize(size);
    localStorage.setItem("wizardTextSize", size);
  };

  const optionFontSize =
    textSize === "small" ? "14px" : textSize === "large" ? "22px" : "18px";
  const modalTitleFontSize =
    textSize === "small" ? "15px" : textSize === "large" ? "22px" : "18px";
  const modalTextFontSize =
    textSize === "small" ? "13px" : textSize === "large" ? "18px" : "14px";
  const optionBoxHeight =
    textSize === "small" ? "85px" : textSize === "large" ? "125px" : "100px";
  const optionBoxWidth =
    textSize === "small" ? "190px" : textSize === "large" ? "260px" : "195px";
  // MUI Grid md value: smaller number = more columns per row
  // small → 2 (6/row), medium → 3 (4/row), large → 4 (3/row)
  const gridMd = textSize === "small" ? 3 : textSize === "large" ? 4 : 3;

  // ─── Location data (flat list for the dropdown) ───────────────────────────
  const [locationsData, setLocationsData] = useState<
    { value: string; label: string; scroll_downs: ScrollDown[] }[]
  >([]);

  // ─── Per-location scroll_down dialog state ────────────────────────────────
  // The location whose scroll_downs we are currently viewing in the sub-dialog
  const [activeLocationForScrollDown, setActiveLocationForScrollDown] =
    useState<{
      value: string;
      label: string;
      scroll_downs: ScrollDown[];
    } | null>(null);

  // Which context is the scroll_down sub-dialog being shown for
  const [scrollDownDialogContext, setScrollDownDialogContext] = useState<
    "complaint" | "otherSymptom" | "examination" | "impression" | null
  >(null);

  // ─── Build locationsData from locationList ────────────────────────────────
  useEffect(() => {
    if (!Array.isArray(locationList)) {
      setLocationsData([]);
      return;
    }
    const mapped = [...locationList].map((loc: LocationModal) => ({
      value: loc.description,
      label: loc.description,
      scroll_downs: Array.isArray(loc.scroll_downs)
        ? [...loc.scroll_downs].sort((a, b) => a.priority - b.priority)
        : [],
    }));
    setLocationsData(mapped);
  }, [locationList]);

  // ─── Helpers ──────────────────────────────────────────────────────────────

  /**
   * Toggle a location + its scroll downs for the given context
   */
  const toggleLocationSelection = (
    locValue: string,
    locLabel: string,
    currentList: LocationWithScrollDowns[],
    setter: (val: LocationWithScrollDowns[]) => void
  ) => {
    const existingIndex = currentList.findIndex(
      (item) => item.description === locValue
    );

    if (existingIndex >= 0) {
      // Remove the location
      setter(currentList.filter((_, i) => i !== existingIndex));
    } else {
      // Add the location with empty scroll downs
      setter([...currentList, { description: locValue, scrollDowns: [] }]);
    }
  };

  /**
   * Opens the scroll_down sub-dialog for a given location + context.
   * Only opens if the location has scroll_downs.
   */
  const openScrollDownDialog = (
    loc: { value: string; label: string; scroll_downs: ScrollDown[] },
    context: "complaint" | "otherSymptom" | "examination" | "impression"
  ) => {
    if (loc.scroll_downs && loc.scroll_downs.length > 0) {
      setActiveLocationForScrollDown(loc);
      setScrollDownDialogContext(context);
    }
  };

  const closeScrollDownDialog = () => {
    setActiveLocationForScrollDown(null);
    setScrollDownDialogContext(null);
  };

  /**
   * Toggle a scroll_down option for the active location in the correct context.
   */
  const toggleScrollDownForLocation = (sdDescription: string) => {
    if (!activeLocationForScrollDown || !scrollDownDialogContext) return;
    const locValue = activeLocationForScrollDown.value;

    const updateLocationScrollDowns = (
      prev: LocationWithScrollDowns[]
    ): LocationWithScrollDowns[] => {
      return prev.map((item) => {
        if (item.description === locValue) {
          const updated = item.scrollDowns.includes(sdDescription)
            ? item.scrollDowns.filter((d) => d !== sdDescription)
            : [...item.scrollDowns, sdDescription];
          return { ...item, scrollDowns: updated };
        }
        return item;
      });
    };

    if (scrollDownDialogContext === "complaint") {
      setComplaintLocation(updateLocationScrollDowns);
    } else if (scrollDownDialogContext === "otherSymptom") {
      setOtherSymptomLocation(updateLocationScrollDowns);
    } else if (scrollDownDialogContext === "examination") {
      setExaminationLocation(updateLocationScrollDowns);
    } else if (scrollDownDialogContext === "impression") {
      setImpressionLocation?.(updateLocationScrollDowns);
    }
  };

  const getSelectedScrollDownsForLocation = (): string[] => {
    if (!activeLocationForScrollDown || !scrollDownDialogContext) return [];

    let currentList: LocationWithScrollDowns[] = [];
    if (scrollDownDialogContext === "complaint") {
      currentList = complaintLocation;
    } else if (scrollDownDialogContext === "otherSymptom") {
      currentList = otherSymptomLocation;
    } else if (scrollDownDialogContext === "examination") {
      currentList = examinationLocation || [];
    } else if (scrollDownDialogContext === "impression") {
      currentList = impressionLocation || [];
    }

    const locationItem = currentList.find(
      (item) => item.description === activeLocationForScrollDown.value
    );
    return locationItem ? locationItem.scrollDowns : [];
  };

  // ─── Existing logic (unchanged) ───────────────────────────────────────────

  const selectClassNames = {
    control: () =>
      "min-h-[48px] rounded-xl border border-borderPrimary bg-surfacePrimary px-2 text-textPrimary focus-within:border-brand-400 focus-within:ring-2",
    menu: () =>
      "mt-2 rounded-xl border border-borderPrimary bg-surfacePrimary shadow-lg",
    option: ({ isFocused, isSelected }: any) =>
      `px-4 py-2 cursor-pointer ${isFocused ? "bg-brand-50" : ""} ${isSelected ? "bg-brand-500 text-white" : "text-textPrimary"
      }`,
    singleValue: () => "text-textPrimary",
  };

  const handleButtonClick = (id: any) => setSelectedButton(id);

  const [defaultBtn] = useState([
    { id: "temp", desc: "Temperature", units: ["a", "b"] },
    { id: "bp", desc: "Blood Pressure", units: ["a", "b"] },
    { id: "hr", desc: "Heart Rate", units: ["a", "b"] },
    {
      id: "height&weight",
      desc: "Height & Weight",
      units: ["a", "b", "c", "d", "e", "f"],
    },
    { id: "bmi", desc: "Body Mass Index", units: ["a", "b"] },
  ]);

  const handleComplaintClick = (item: string) => {
    let page_name = "";
    if (page === 1) {
      page_name = "Systems";
      setSelectedValue((prev) => ({ ...prev, system: item }));
    } else if (page === 2) {
      page_name = "Complaints";
      setSelectedValue((prev) => ({ ...prev, complaint: item }));
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
        setSelectedSubComp([]);
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
        const comp: EITModal = complaintList.filter((x) => x._id === item)[0];
        if (comp.scroll_downs && comp.scroll_downs.length > 0) {
          setSubComp(
            comp.scroll_downs.map((sd: any) => ({
              description: sd.description,
              priority: sd.priority,
            }))
          );
          setCompId(comp._id);
        }
      }
    } else if (page === 3) {
      page_name = "OtherSymptoms";
      setSelectedValue((prev) => ({ ...prev, otherSymptom: item }));
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
        setSelectedSubOtherSymptom(
          selectedSubOtherSymptom.filter((s) => s.id !== item)
        );
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
        const otherSym: EITModal = otherSymptomList.filter(
          (x) => x._id === item
        )[0];
        if (otherSym.scroll_downs && otherSym.scroll_downs.length > 0) {
          setSubOtherSymptom(
            otherSym.scroll_downs.map((sd: any) => ({
              description: sd.description,
              priority: sd.priority,
            }))
          );
          setOtherSymptomId(otherSym._id);
        }
      }
    } else if (page === 4) {
      page_name = "History";
      setSelectedValue((prev) => ({ ...prev, history: item }));
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
        setSelectedSubHistory(selectedSubHistory.filter((s) => s.id !== item));
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
        const hist: EITModal = historyList.filter((x) => x._id === item)[0];
        if (hist.scroll_downs && hist.scroll_downs.length > 0) {
          setSubHistory(
            hist.scroll_downs.map((sd: any) => ({
              description: sd.description,
              priority: sd.priority,
            }))
          );
          setHistoryId(hist._id);
        }
      }
    } else if (page === 5) {
      page_name = "Examinations";
      setSelectedValue((prev) => ({ ...prev, examination: item }));
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
        setSelectedSubExams(selectedSubExams.filter((s) => s.id !== item));
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
        const exam: ExaminationModal = examinationList.filter(
          (x) => x._id === item
        )[0];
        if (exam && exam.scroll_downs && exam.scroll_downs.length > 0) {
          try {
            const processed = exam.scroll_downs
              .map((sd: any) =>
                sd && typeof sd === "object" && "description" in sd
                  ? { description: sd.description, priority: sd.priority || 0 }
                  : { description: String(sd || ""), priority: 0 }
              )
              .filter((sd: any) => sd.description);
            setSubExams(processed);
            setExamId(exam._id);
          } catch {
            setSnackbar({
              open: true,
              message: "Error processing examination data",
              severity: "error",
            });
          }
        }
      }
    } else if (page === 6) {
      page_name = "Assessments";
      setSelectedValue((prev) => ({ ...prev, impression: item }));
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
        setSelectedSubImp(selectedSubImp.filter((s) => s.id !== item));
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
        const imp: EITModal = impressionList.filter((x) => x._id === item)[0];
        if (imp.scroll_downs && imp.scroll_downs.length > 0) {
          setSubImp(
            imp.scroll_downs.map((sd: any) => ({
              description: sd.description,
              priority: sd.priority,
            }))
          );
          setImpId(imp._id);
        }
      }
    } else if (page === 7) {
      page_name = "Plans";
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
        setSelectedSubTreatPlan(
          selectedSubTreatPlan.filter((s) => s.id !== item)
        );
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
        const tp: EITModal = treatmentList.filter((x) => x._id === item)[0];
        if (tp.scroll_downs && tp.scroll_downs.length > 0) {
          setSubTreatPlan(
            tp.scroll_downs.map((sd: any) => ({
              description: sd.description,
              priority: sd.priority,
            }))
          );
          setTreatPlanId(tp._id);
        }
      }
    }

    if (page === 1) {
      const x = selectedOptionList.filter((o) => o.page_name !== "Systems");
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(x.filter((o) => o.id !== item));
      } else {
        setSelectedOptionList([...x, { id: item, page_name }]);
      }
    } else if (page === 2) {
      const x = selectedOptionList.filter((o) => o.page_name !== "Complaints");
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(x.filter((o) => o.id !== item));
      } else {
        setSelectedOptionList([...x, { id: item, page_name }]);
      }
    } else if (page === 5) {
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
        setSelectedSubExams(selectedSubExams.filter((s) => s.id !== item));
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
        const exam: ExaminationModal = examinationList.filter(
          (x) => x._id === item
        )[0];
        if (exam && exam.scroll_downs && exam.scroll_downs.length > 0) {
          try {
            const processed = exam.scroll_downs
              .map((sd: any) =>
                sd && typeof sd === "object" && "description" in sd
                  ? { description: sd.description, priority: sd.priority || 0 }
                  : { description: String(sd || ""), priority: 0 }
              )
              .filter((sd: any) => sd.description);
            setSubExams(processed);
            setExamId(exam._id);
          } catch {
            setSnackbar({
              open: true,
              message: "Error processing examination data",
              severity: "error",
            });
          }
        }
      }
    } else {
      if (selectedOptionList.some((o) => o.id === item)) {
        setSelectedOptionList(selectedOptionList.filter((o) => o.id !== item));
      } else {
        setSelectedOptionList([...selectedOptionList, { id: item, page_name }]);
      }
    }
  };

  const handleSubOtherSymptomClick = (item: string) => {
    const isSelected = selectedSubOtherSymptom.some(
      (o) => o.id === otherSymptomId && o.description === item
    );
    if (isSelected) {
      setSelectedSubOtherSymptom(
        selectedSubOtherSymptom.filter(
          (o) => !(o.id === otherSymptomId && o.description === item)
        )
      );
    } else {
      setSelectedSubOtherSymptom([
        ...selectedSubOtherSymptom,
        { id: otherSymptomId, description: item, system_id: [] },
      ]);
    }
  };

  const handleSubHistoryClick = (item: string) => {
    const isSelected = selectedSubHistory.some(
      (o) => o.id === historyId && o.description === item
    );
    if (isSelected) {
      setSelectedSubHistory(
        selectedSubHistory.filter(
          (o) => !(o.id === historyId && o.description === item)
        )
      );
    } else {
      setSelectedSubHistory([
        ...selectedSubHistory,
        { id: historyId, description: item, system_id: [] },
      ]);
    }
  };

  const handleSubExamClick = (item: string) => {
    try {
      const isSelected = selectedSubExams.some(
        (o) => o.id === examId && o.description === item
      );
      if (isSelected) {
        setSelectedSubExams(
          selectedSubExams.filter(
            (o) => !(o.id === examId && o.description === item)
          )
        );
      } else {
        setSelectedSubExams([
          ...selectedSubExams,
          { id: examId, description: item, system_id: [] },
        ]);
      }
    } catch {
      setSnackbar({
        open: true,
        message: "An error occurred while selecting the sub-examination",
        severity: "error",
      });
    }
  };

  const handleSubImpClick = (item: string) => {
    const isSelected = selectedSubImp.some(
      (o) => o.id === impId && o.description === item
    );
    if (isSelected) {
      setSelectedSubImp(
        selectedSubImp.filter(
          (o) => !(o.id === impId && o.description === item)
        )
      );
    } else {
      setSelectedSubImp([
        ...selectedSubImp,
        { id: impId, description: item, system_id: [] },
      ]);
    }
  };

  const handleSubCompClick = (item: string) => {
    try {
      if (
        selectedSubComp.some(
          (o: wizardDisplayModal) => o.id === compId && o.description === item
        )
      ) {
        setSelectedSubComp(
          selectedSubComp.filter(
            (o: wizardDisplayModal) =>
              !(o.id === compId && o.description === item)
          )
        );
      } else {
        setSelectedSubComp([
          ...selectedSubComp,
          { id: compId, description: item, system_id: [] },
        ]);
      }
    } catch {
      setSnackbar({
        open: true,
        message: "An error occurred while selecting the sub-complaint",
        severity: "error",
      });
    }
  };

  const handleSubTreatPlanClick = (item: string) => {
    const isSelected = selectedSubTreatPlan.some(
      (o) => o.id === treatPlanId && o.description === item
    );
    if (isSelected) {
      setSelectedSubTreatPlan(
        selectedSubTreatPlan.filter(
          (o) => !(o.id === treatPlanId && o.description === item)
        )
      );
    } else {
      setSelectedSubTreatPlan([
        ...selectedSubTreatPlan,
        { id: treatPlanId, description: item, system_id: [] },
      ]);
    }
  };

  useEffect(() => {
    updateReportList(
      selectedOptionList,
      selectedSubOtherSymptom,
      selectedSubHistory,
      selectedSubExams,
      selectedSubImp,
      selectedSubComp,
      selectedSubTreatPlan
    );
  }, [
    selectedOptionList,
    selectedSubOtherSymptom,
    selectedSubHistory,
    selectedSubExams,
    data,
    selectedSubImp,
    selectedSubComp,
    selectedSubTreatPlan,
  ]);

  useEffect(() => {
    if (resetTrigger) {
      setSelectedOptionList([]);
      setSelectedSubComp([]);
      setSelectedSubOtherSymptom([]);
      setSelectedSubHistory([]);
      setSelectedSubExams([]);
      setSelectedSubImp([]);
      setSelectedSubTreatPlan([]);
      setSelectedValue({
        system: "",
        complaint: "",
        otherSymptom: "",
        history: "",
        examination: "",
        impression: "",
        treatmentPlans: "",
      });
      setData([]);
      setPage(1);
      setResetTrigger(false);
      setComplaintLocation([]);
      setOtherSymptomLocation([]);
      setExaminationLocation([]);
      setImpressionLocation?.([]);
    }
  }, [resetTrigger, setResetTrigger]);

  const handleNext = () => {
    if (page === 1) {
      setToPage(
        complaintList,
        2,
        "What is the chief complaint?",
        "(Please choose only one option)",
        selectedValue.system
      );
      setPage(2);
    } else if (page === 2) {
      setToPage(
        otherSymptomList,
        3,
        "Other Symptoms:",
        "",
        selectedValue.otherSymptom
      );
      setPage(3);
    } else if (page === 3) {
      setToPage(historyList, 4, "History:", "", selectedValue.history);
      setPage(4);
    } else if (page === 4) {
      setToPage(
        examinationList,
        5,
        "On Examination:",
        "",
        selectedValue.examination
      );
      setPage(5);
    } else if (page === 5) {
      setToPage(
        impressionList,
        6,
        "Assessments:",
        "",
        selectedValue.impression
      );
      setPage(6);
    } else if (page === 6) {
      setToPage(treatmentList, 7, "Plan:", "", selectedValue.treatmentPlans);
      setPage(7);
    } else if (page === 7) {
      setIsCompleted(true);
    }
  };

  const handlePrevious = () => {
    if (page === 7) {
      setToPage(
        impressionList,
        5,
        "Assessments:",
        "",
        selectedValue.impression
      );
      setPage(6);
    }
    if (page === 6) {
      setToPage(
        examinationList,
        4,
        "On Examination:",
        "",
        selectedValue.examination
      );
      setPage(5);
    }
    if (page === 5) {
      setToPage(historyList, 3, "History:", "", selectedValue.history);
      setPage(4);
    }
    if (page === 4) {
      setToPage(
        otherSymptomList,
        3,
        "Other Symptoms:",
        "",
        selectedValue.otherSymptom
      );
      setPage(3);
    }
    if (page === 3) {
      setToPage(
        complaintList,
        2,
        "What is the chief complaint?",
        "(Please choose only one option)",
        selectedValue.complaint
      );
      setPage(2);
    }
    if (page === 2) {
      setToPage(systemList, 1, "Systems", "", selectedValue.system);
      setPage(1);
    }
  };

  const setToPage = (
    list: any,
    optionNumber: number,
    heading: string,
    subHeading: string,
    selectedId?: string
  ) => {
    // Sort by the currently selected system's priority so items appear in
    // the order the admin configured for that system. Falls back to base priority
    // when no system is chosen yet (e.g. on the Systems selection page).
    const systemId = selectedValue.system || "";
    let tempList: wizardDisplayModal[] =
      handleDisplayListConverstion(list, systemId) ?? [];
    let filtered = tempList.filter((obj) =>
      obj.system_id?.includes(selectedValue.system)
    );
    setDisplayList(
      selectedId === "system" || heading === "Systems" ? tempList : filtered
    );
    setDisplayObj({ optionNumber, heading, subHeading });
  };

  function handleDisplayListConverstion(tempList: any, systemId?: string): wizardDisplayModal[] {
    if (!tempList || tempList.length === 0) return [];
    return tempList
      .map((item: any) => ({
        id: item._id,
        description: item.description,
        system_id: item.system_id,
        priority: item.priority,
      }))
      .sort(
        (a: wizardDisplayModal, b: wizardDisplayModal) => {
          const pa = getSystemPriority(a.priority, systemId);
          const pb = getSystemPriority(b.priority, systemId);
          return pa - pb;
        }
      );
  }

  const onRemoveClick = (description: string) => {
    setData((prev) => prev.filter((item) => item.description !== description));
  };

  const onSubmitClick = (description: string, value: defaultBtnObj[]) => {
    const matched = data.find((e) => e.description === description);
    if (!matched && description !== "Body Mass Index") {
      setData((prev) => [...prev, { description, value }]);
    }
    const heightAndWeightData = data.find(
      (e) => e.description === "Height & Weight"
    );
    if (description === "Body Mass Index") {
      if (!heightAndWeightData) {
        setSnackbar({
          open: true,
          message: "Weight and Height are required",
          severity: "error",
        });
        return;
      }
      if (heightAndWeightData.value && heightAndWeightData.value.length > 0) {
        const hAndw = heightAndWeightData.value;
        let bmiData: defaultBtnObj = Object();
        const weightKG = hAndw.find((x) => x.unitValue === "Kilos");
        const weightPounds = hAndw.find((x) => x.unitValue === "Pounds");
        if (weightKG && weightKG.inputValue) {
          const heightMeters =
            parseFloat(
              hAndw.find((x) => x.unitValue === "Centimeters")?.inputValue
            ) / 100;
          bmiData = {
            inputValue: (
              parseFloat(weightKG.inputValue) /
              (heightMeters * heightMeters)
            ).toFixed(2),
            unitValue: "BMI",
          };
        } else if (weightPounds && weightPounds.inputValue) {
          const hF = parseFloat(
            hAndw.find((x) => x.unitValue === "Feets")?.inputValue
          );
          const hI = parseFloat(
            hAndw.find((x) => x.unitValue === "Inches")?.inputValue
          );
          const totalInches = hF * 12 + hI;
          bmiData = {
            inputValue: (
              (703 * parseFloat(weightPounds.inputValue)) /
              (totalInches * totalInches)
            ).toFixed(2),
            unitValue: "BMI",
          };
        }
        setData((prev) => [...prev, { description, value: [bmiData] }]);
      }
    }
  };

  React.useEffect(() => {
    localStorage.setItem("data", JSON.stringify(data));
  }, [data]);

  React.useEffect(() => {
    if (page === 1) {
      setToPage(
        systemList,
        1,
        "Systems",
        "",
        selectedValue.system ? selectedValue.system : "system"
      );
      if (!selectedValue.system) setSelectedOptionList([]);
    }
  }, [page]);

  const toggleSort = () => {
    setIsSortedByP(false);
    setIsSorted((prev) => {
      const next = !prev;
      if (displayList && displayList.length > 0) {
        setDisplayList(
          [...displayList].sort((a, b) =>
            next
              ? b.description.localeCompare(a.description)
              : a.description.localeCompare(b.description)
          )
        );
      }
      return next;
    });
  };

  const resetSort = () => {
    setIsSortedByP(true);
    setIsSorted(false);
    if (displayList && displayList.length > 0) {
      setDisplayList(
        [...displayList].sort((a, b) => {
          const pa = getSystemPriority(a.priority, selectedValue.system);
          const pb = getSystemPriority(b.priority, selectedValue.system);
          return pa - pb;
        })
      );
    }
  };

  useEffect(() => {
    if (
      page === 2 &&
      duration &&
      duration > 0 &&
      (!durationType || durationType === "")
    )
      setDurationType("Seconds");
    if (
      page === 3 &&
      otherSymptomDuration &&
      otherSymptomDuration > 0 &&
      (!otherSymptomDurationType || otherSymptomDurationType === "")
    )
      setOtherSymptomDurationType("Seconds");
    if (
      page === 4 &&
      historyDuration &&
      historyDuration > 0 &&
      (!historyDurationType || historyDurationType === "")
    )
      setHistoryDurationType("Seconds");
  }, [duration, otherSymptomDuration, historyDuration]);

  // ─── Scroll-down sub-dialog (shared across all contexts) ─────────────────

  const ScrollDownSubDialog = () => {
    if (!activeLocationForScrollDown || !scrollDownDialogContext) return null;
    const selectedSDs = getSelectedScrollDownsForLocation();

    return (
      <div className="bg-gray-800/80 fixed inset-0 z-[100000] flex items-center justify-center backdrop-blur-sm">
        <div className="relative z-[1000] mx-4 flex max-h-[90vh] max-w-5xl flex-col rounded-2xl bg-surfacePrimary p-8 shadow-xl dark:bg-navy-800">
          <button
            className="absolute right-4 top-3 text-2xl font-bold text-textSecondary hover:text-textPrimary dark:text-gray-300"
            onClick={closeScrollDownDialog}
          >
            &times;
          </button>
          <div className="flex max-h-full flex-col gap-4 overflow-hidden">
            <h2
              style={{ fontSize: modalTitleFontSize }}
              className="shrink-0 font-semibold text-textPrimary"
            >
              Options for:{" "}
              <span className="text-blue-500">
                {activeLocationForScrollDown.label}
              </span>
            </h2>
            <div className="no-scrollbar mb-2 w-full flex-1 overflow-y-auto">
              <div className="flex flex-wrap gap-2">
                {activeLocationForScrollDown.scroll_downs
                  .sort((a, b) => a.priority - b.priority)
                  .map((sd, i) => {
                    const isSelected = selectedSDs.includes(sd.description);
                    return (
                      <button
                        key={i}
                        onClick={() =>
                          toggleScrollDownForLocation(sd.description)
                        }
                        style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                        className={`${isSelected ? "!bg-brand-500 !text-white" : ""
                          } linear flex items-center justify-center rounded-lg bg-surfaceSecondary p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70`}
                      >
                        {sd.description}
                      </button>
                    );
                  })}
              </div>
            </div>
            <div className="flex shrink-0 justify-end">
              <button
                onClick={closeScrollDownDialog}
                style={{ fontSize: modalTextFontSize }}
                className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ─── Duration dialog helper ───────────────────────────────────────────────

  const durationOptions = (d: number | null) => {
    const units = [
      { singular: "Second", plural: "Seconds" },
      { singular: "Minute", plural: "Minutes" },
      { singular: "Hour", opacity: 1, plural: "Hours" },
      { singular: "Day", plural: "Days" },
      { singular: "Week", plural: "Weeks" },
      { singular: "Month", plural: "Months" },
      { singular: "Year", plural: "Years" },
    ];
    if (d === null || d === undefined || typeof d !== "number" || isNaN(d)) {
      const list: JSX.Element[] = [
        <option
          key="placeholder"
          value=""
          className="bg-surfacePrimary text-textPrimary"
        >
          Select unit
        </option>,
      ];
      units.forEach((o) => {
        list.push(
          <option
            key={o.singular}
            value={o.singular}
            className="bg-surfacePrimary text-textPrimary"
          >
            {o.singular}
          </option>
        );
        list.push(
          <option
            key={o.plural}
            value={o.plural}
            className="bg-surfacePrimary text-textPrimary"
          >
            {o.plural}
          </option>
        );
      });
      return list;
    }
    return units.map((o) => (
      <option
        key={o.plural}
        value={d === 1 ? o.singular : o.plural}
        className="bg-surfacePrimary text-textPrimary"
      >
        {d === 1 ? o.singular : o.plural}
      </option>
    ));
  };


  const [isVitalsOpened, setIsVitalsOpened] = useState(false);

  // ─── RENDER ───────────────────────────────────────────────────────────────

  return (
    <div className="flex h-full overflow-hidden flex-col">
      {voiceMode ? (
        <VoiceNoteGeneration
          catalog={voiceCatalog}
          onGenerated={(report: VoiceNoteReport) => onVoiceReportGenerated?.(report as any)}
          onCreateNote={() => setIsCompleted(true)}
          onCancel={leaveVoiceMode}
        />
      ) : (
        <>
      {/* Header */}
      <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-[18px] font-semibold text-textPrimary">
          {displayObj?.heading ?? ""}
        </h1>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={enterVoiceMode}
            className="flex h-9 items-center justify-center rounded-lg bg-green-600 px-3 text-sm font-bold text-white transition hover:bg-green-700"
          >
            Voice Note Generation
          </button>
          {/* Text Size Customization Switch Button (Left of Sorting Button) */}
          <div className="flex h-9 items-center rounded-lg border border-borderPrimary bg-surfaceSecondary p-1">
            <span className="flex items-center gap-1 px-1.5 text-xs font-bold text-textSecondary">
              <MdFormatSize className="h-4 w-4" />
            </span>
            <button
              type="button"
              onClick={() => handleTextSizeChange("small")}
              className={`h-full rounded-md px-2.5 text-xs font-bold transition-all ${textSize === "small"
                ? "bg-brand-500 text-white shadow-sm"
                : "text-textSecondary hover:text-brand-500"
                }`}
            >
              A
            </button>
            <button
              type="button"
              onClick={() => handleTextSizeChange("medium")}
              className={`h-full rounded-md px-2.5 text-lg font-bold transition-all ${textSize === "medium"
                ? "bg-brand-500 text-white shadow-sm"
                : "text-textSecondary hover:text-brand-500"
                }`}
            >
              A
            </button>
            <button
              type="button"
              onClick={() => handleTextSizeChange("large")}
              className={`h-full rounded-md px-2.5 text-xl font-bold transition-all ${textSize === "large"
                ? "bg-brand-500 text-white shadow-sm"
                : "text-textSecondary hover:text-brand-500"
                }`}
            >
              A
            </button>
          </div>

          <button
            onClick={toggleSort}
            className="flex h-9 items-center justify-center rounded-lg bg-surfaceSecondary px-3 text-sm font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
          >
            {isSorted ? "Sort Z-A" : "Sort A-Z"}
          </button>
          <button
            title="Reset sorting"
            disabled={isSortedByP}
            onClick={resetSort}
            className="flex h-9 w-9 items-center justify-center rounded-lg bg-green-700 text-sm font-bold text-white transition duration-200 hover:cursor-pointer hover:bg-green-700/80 active:bg-green-700/70 disabled:bg-gray-300 disabled:text-[#00000067] disabled:hover:cursor-not-allowed dark:bg-navy-700 dark:text-white"
          >
            <MdRefresh className="h-4 w-4" />
          </button>
        </div>
      </div>
      <p className="w-[100%] text-[16px] text-textSecondary sm:w-[100%]">
        {displayObj?.subHeading ?? ""}
      </p>

      {/* Main list — only this region scrolls */}
      <div className="no-scrollbar mt-5 flex min-h-0 flex-1 flex-wrap justify-center overflow-y-auto overflow-x-hidden">
        <Grid container spacing={1} alignItems="stretch">

          {/* Vitals button — shown only on examination step (page 5) */}
          {page === 5 && (() => {
            const hasAnyVital = defaultBtn.some((e) =>
              data.some((item) => item.description === e.desc)
            );
            return (
              <Grid item xs={12} sm={6} md={gridMd as any}>
                <button
                  onClick={() => setIsVitalsOpened(true)}
                  style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                  className={`${hasAnyVital ? "!bg-brand-500 !text-white" : ""} linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                >
                  Vitals
                </button>
              </Grid>
            );
          })()}

          {displayList && displayList.length > 0 ? (
            displayList.map((x, i) => (
              <Grid key={i} item xs={12} sm={6} md={gridMd as any}>
                <button
                  onClick={() => handleComplaintClick(x.id)}
                  style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                  className={`${selectedOptionList.find((c) => c.id === x.id)
                    ? "!bg-brand-500 !text-white"
                    : ""
                    } linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                >
                  {x.description}
                </button>
              </Grid>
            ))
          ) : page !== 5 ? (
            <p className="text-red mt-3 w-[100%] text-[16px] sm:w-[70%]">
              There are no further sub-classes!
            </p>
          ) : null}
        </Grid>
      </div>

      {/* ── Body-Model Location Modals (complaint, other symptom, examination) ── */}
      <SelectLocationModal
        title="What is the location of the chief complaint?"
        isOpen={page === 2 && locationDialog}
        onClose={() => setLocationDialog(false)}
        selectedLocations={complaintLocation}
        onSave={(locations) => setComplaintLocation(locations)}
        context="complaint"
        locationList={locationList}
        textSize={textSize}
      />

      <SelectLocationModal
        title="What is the location of the other symptoms?"
        isOpen={page === 3 && otherSymptomLocationDialog}
        onClose={() => setOtherSymptomLocationDialog(false)}
        selectedLocations={otherSymptomLocation}
        onSave={(locations) => setOtherSymptomLocation(locations)}
        context="otherSymptom"
        locationList={locationList}
        textSize={textSize}
      />

      <SelectLocationModal
        title="What is the location of the examination?"
        isOpen={page === 5 && examinationLocationDialog}
        onClose={() => setExaminationLocationDialog(false)}
        selectedLocations={examinationLocation ?? []}
        onSave={(locations) => setExaminationLocation(locations)}
        context="examination"
        locationList={locationList}
        textSize={textSize}
      />

      <SelectLocationModal
        title="What is the location of the assessment?"
        isOpen={page === 6 && impressionLocationDialog}
        onClose={() => setImpressionLocationDialog(false)}
        selectedLocations={impressionLocation ?? []}
        onSave={(locations) => setImpressionLocation && setImpressionLocation(locations)}
        context="impression"
        locationList={locationList}
        textSize={textSize}
      />

      {/* ── Duration Dialogs ── */}
      {page === 2 && durationDialog && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="duration-dialog wizard-dialog-body relative rounded-2xl bg-surfacePrimary p-8 shadow-xl">
            <button
              className="absolute right-4 top-3 text-2xl font-bold text-textSecondary hover:text-textPrimary"
              onClick={() => setDurationDialog(false)}
            >
              &times;
            </button>
            <div className="wizardBody flex flex-col gap-6">
              <h2
                style={{ fontSize: modalTitleFontSize }}
                className="font-semibold text-textPrimary"
              >
                What is the duration of the chief complaint?
              </h2>
              <div className="flex flex-row gap-3">
                <input
                  autoFocus
                  style={{ fontSize: modalTextFontSize }}
                  className="h-12 flex-1 rounded-xl border border-shadowSecondary bg-surfacePrimary px-4 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
                  type="number"
                  min={1}
                  max={60}
                  value={duration ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    setDuration(val === "" ? null : parseInt(val));
                  }}
                  placeholder="Enter number"
                />
                <select
                  style={{ fontSize: modalTextFontSize }}
                  className="h-12 flex-1 rounded-xl border border-shadowSecondary bg-surfacePrimary px-4 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
                  value={durationType}
                  onChange={(e) => setDurationType(e.target.value)}
                >
                  {durationOptions(duration)}
                </select>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => setDurationDialog(false)}
                  style={{ fontSize: modalTextFontSize }}
                  className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 3 && otherSymptomDurationDialog && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="duration-dialog wizard-dialog-body relative rounded-2xl bg-surfacePrimary p-8 shadow-xl">
            <button
              className="absolute right-4 top-3 text-2xl font-bold text-textSecondary hover:text-textPrimary"
              onClick={() => setOtherSymptomDurationDialog(false)}
            >
              &times;
            </button>
            <div className="wizardBody flex flex-col gap-6">
              <h2
                style={{ fontSize: modalTitleFontSize }}
                className="font-semibold text-textPrimary"
              >
                What is the duration of the other symptoms?
              </h2>
              <div className="flex flex-row gap-3">
                <input
                  autoFocus
                  style={{ fontSize: modalTextFontSize }}
                  className="h-12 flex-1 rounded-xl border border-shadowSecondary bg-surfacePrimary px-4 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
                  type="number"
                  min={1}
                  max={60}
                  value={otherSymptomDuration ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    setOtherSymptomDuration(val === "" ? null : parseInt(val));
                  }}
                  placeholder="Enter number"
                />
                <select
                  style={{ fontSize: modalTextFontSize }}
                  className="h-12 flex-1 rounded-xl border border-shadowSecondary bg-surfacePrimary px-4 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
                  value={otherSymptomDurationType}
                  onChange={(e) => setOtherSymptomDurationType(e.target.value)}
                >
                  {durationOptions(otherSymptomDuration)}
                </select>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => setOtherSymptomDurationDialog(false)}
                  style={{ fontSize: modalTextFontSize }}
                  className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 4 && historyDurationDialog && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="duration-dialog wizard-dialog-body relative rounded-2xl bg-surfacePrimary p-8 shadow-xl">
            <button
              className="absolute right-4 top-3 text-2xl font-bold text-textSecondary hover:text-textPrimary"
              onClick={() => setHistoryDurationDialog(false)}
            >
              &times;
            </button>
            <div className="wizardBody flex flex-col gap-6">
              <h2
                style={{ fontSize: modalTitleFontSize }}
                className="font-semibold text-textPrimary"
              >
                What is the duration of the history?
              </h2>
              <div className="flex flex-row gap-3">
                <input
                  autoFocus
                  style={{ fontSize: modalTextFontSize }}
                  className="h-12 flex-1 rounded-xl border border-shadowSecondary bg-surfacePrimary px-4 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
                  type="number"
                  min={1}
                  max={60}
                  value={historyDuration ?? ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    setHistoryDuration(val === "" ? null : parseInt(val));
                  }}
                  placeholder="Enter number"
                />
                <select
                  style={{ fontSize: modalTextFontSize }}
                  className="h-12 flex-1 rounded-xl border border-shadowSecondary bg-surfacePrimary px-4 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
                  value={historyDurationType}
                  onChange={(e) => setHistoryDurationType(e.target.value)}
                >
                  {durationOptions(historyDuration)}
                </select>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => setHistoryDurationDialog(false)}
                  style={{ fontSize: modalTextFontSize }}
                  className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Condition Selection Dialogs (responsive font sizes) ── */}
      {page === 2 && subComp && subComp.length > 0 && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="relative rounded-2xl border border-shadowSecondary bg-surfacePrimary p-8 shadow-xl">
            <span
              className="float-right text-[28px] font-bold text-textSecondary hover:cursor-pointer hover:text-textPrimary hover:no-underline focus:cursor-pointer focus:text-textPrimary focus:no-underline"
              onClick={() => {
                setSubComp([]);
                setCompId("");
              }}
            >
              &times;
            </span>
            <div className="wizardBody">
              <div className="mt-5 flex flex-wrap p-5">
                <h1
                  style={{ fontSize: modalTitleFontSize }}
                  className="mb-3 w-[100%] text-left font-semibold text-textPrimary"
                >
                  Select Main Complaint Condition
                </h1>
                {subComp.map((x, i) => (
                  <button
                    key={i}
                    onClick={() => handleSubCompClick(x.description)}
                    style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                    className={`${selectedSubComp.find(
                      (c) =>
                        c.id === compId && c.description === x.description
                    )
                      ? "!bg-brand-500 !text-white"
                      : ""
                      } linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                  >
                    {x.description}
                  </button>
                ))}
              </div>
              <div className="mt-auto flex flex-col">
                <div className="flex flex-row justify-end">
                  <button
                    onClick={() => {
                      setSubComp([]);
                      setCompId("");
                    }}
                    style={{ fontSize: modalTextFontSize }}
                    className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 3 && subOtherSymptom && subOtherSymptom.length > 0 && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="relative rounded-2xl border border-shadowSecondary bg-surfacePrimary p-8 shadow-xl">
            <span
              className="float-right text-[28px] font-bold text-textSecondary hover:cursor-pointer hover:text-textPrimary hover:no-underline focus:cursor-pointer focus:text-textPrimary focus:no-underline"
              onClick={() => {
                setSubOtherSymptom([]);
                setOtherSymptomId("");
              }}
            >
              &times;
            </span>
            <div className="wizardBody">
              <div className="mt-5 flex flex-wrap p-5">
                <h1
                  style={{ fontSize: modalTitleFontSize }}
                  className="mb-3 w-[100%] text-left font-semibold text-textPrimary"
                >
                  Select Other Symptom Condition:
                </h1>
                {subOtherSymptom.map((x, i) => (
                  <button
                    key={i}
                    onClick={() => handleSubOtherSymptomClick(x.description)}
                    style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                    className={`${selectedSubOtherSymptom.find(
                      (c) =>
                        c.id === otherSymptomId &&
                        c.description === x.description
                    )
                      ? "!bg-brand-500 !text-white"
                      : ""
                      } linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                  >
                    {x.description}
                  </button>
                ))}
              </div>
              <div className="mt-auto flex flex-col">
                <div className="flex flex-row justify-end">
                  <button
                    onClick={() => {
                      setSubOtherSymptom([]);
                      setOtherSymptomId("");
                    }}
                    style={{ fontSize: modalTextFontSize }}
                    className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 4 && subHistory && subHistory.length > 0 && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="relative rounded-2xl border border-shadowSecondary bg-surfacePrimary p-8 shadow-xl">
            <span
              className="float-right text-[28px] font-bold text-textSecondary hover:cursor-pointer hover:text-textPrimary hover:no-underline focus:cursor-pointer focus:text-textPrimary focus:no-underline"
              onClick={() => {
                setSubHistory([]);
                setHistoryId("");
              }}
            >
              &times;
            </span>
            <div className="wizardBody">
              <div className="mt-5 flex flex-wrap p-5">
                <h1
                  style={{ fontSize: modalTitleFontSize }}
                  className="mb-3 w-[100%] text-left font-semibold text-textPrimary"
                >
                  Select History Condition:
                </h1>
                {subHistory.map((x, i) => (
                  <button
                    key={i}
                    onClick={() => handleSubHistoryClick(x.description)}
                    style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                    className={`${selectedSubHistory.find(
                      (c) =>
                        c.id === historyId && c.description === x.description
                    )
                      ? "!bg-brand-500 !text-white"
                      : ""
                      } linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                  >
                    {x.description}
                  </button>
                ))}
              </div>
              <div className="mt-auto flex flex-col">
                <div className="flex flex-row justify-end">
                  <button
                    onClick={() => {
                      setSubHistory([]);
                      setHistoryId("");
                    }}
                    style={{ fontSize: modalTextFontSize }}
                    className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 5 && subExams && subExams.length > 0 && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="relative rounded-2xl border border-shadowSecondary bg-surfacePrimary p-8 shadow-xl">
            <span
              className="float-right text-[28px] font-bold text-textSecondary hover:cursor-pointer hover:text-textPrimary hover:no-underline focus:cursor-pointer focus:text-textPrimary focus:no-underline"
              onClick={() => {
                setSubExams([]);
                setExamId("");
              }}
            >
              &times;
            </span>
            <div className="wizardBody">
              <div className="mt-5 flex flex-wrap p-5">
                <h1
                  style={{ fontSize: modalTitleFontSize }}
                  className="mb-3 w-[100%] text-left font-semibold text-textPrimary"
                >
                  Select Examination Condition:
                </h1>
                {subExams.map((x, i) => (
                  <button
                    key={i}
                    onClick={() => handleSubExamClick(x.description)}
                    style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                    className={`${selectedSubExams.some(
                      (c) =>
                        c.id === examId && c.description === x.description
                    )
                      ? "!bg-brand-500 !text-white"
                      : ""
                      } linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                  >
                    {x.description}
                  </button>
                ))}
              </div>
              <div className="mt-auto flex flex-col">
                <div className="flex flex-row justify-end">
                  <button
                    onClick={() => {
                      setSubExams([]);
                      setExamId("");
                    }}
                    style={{ fontSize: modalTextFontSize }}
                    className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 6 && subImp && subImp.length > 0 && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="relative rounded-2xl border border-shadowSecondary bg-surfacePrimary p-8 shadow-xl">
            <span
              className="float-right text-[28px] font-bold text-textSecondary hover:cursor-pointer hover:text-textPrimary hover:no-underline focus:cursor-pointer focus:text-textPrimary focus:no-underline"
              onClick={() => {
                setSubImp([]);
                setImpId("");
              }}
            >
              &times;
            </span>
            <div className="wizardBody">
              <div className="mt-5 flex flex-wrap p-5">
                <h1
                  style={{ fontSize: modalTitleFontSize }}
                  className="mb-3 w-[100%] text-left font-semibold text-textPrimary"
                >
                  Select Assessment Condition:
                </h1>
                {subImp.map((x, i) => (
                  <button
                    key={i}
                    onClick={() => handleSubImpClick(x.description)}
                    style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                    className={`${selectedSubImp.find(
                      (c) => c.id === impId && c.description === x.description
                    )
                      ? "!bg-brand-500 !text-white"
                      : ""
                      } linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                  >
                    {x.description}
                  </button>
                ))}
              </div>
              <div className="mt-auto flex flex-col">
                <div className="flex flex-row justify-end">
                  <button
                    onClick={() => {
                      setSubImp([]);
                      setImpId("");
                    }}
                    style={{ fontSize: modalTextFontSize }}
                    className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 7 && subTreatPlan && subTreatPlan.length > 0 && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="relative rounded-2xl border border-shadowSecondary bg-surfacePrimary p-8 shadow-xl">
            <span
              className="float-right text-[28px] font-bold text-textSecondary hover:cursor-pointer hover:text-textPrimary hover:no-underline focus:cursor-pointer focus:text-textPrimary focus:no-underline"
              onClick={() => {
                setSubTreatPlan([]);
                setTreatPlanId("");
              }}
            >
              &times;
            </span>
            <div className="wizardBody">
              <div className="mt-5 flex flex-wrap p-5">
                <h1
                  style={{ fontSize: modalTitleFontSize }}
                  className="mb-3 w-[100%] text-left font-semibold text-textPrimary"
                >
                  Select Plan Condition:
                </h1>
                {subTreatPlan.map((x, i) => (
                  <button
                    key={i}
                    onClick={() => handleSubTreatPlanClick(x.description)}
                    style={{ fontSize: optionFontSize, minHeight: optionBoxHeight, width: optionBoxWidth }}
                    className={`${selectedSubTreatPlan.find(
                      (c) =>
                        c.id === treatPlanId &&
                        c.description === x.description
                    )
                      ? "!bg-brand-500 !text-white"
                      : ""
                      } linear m-1 mr-3 flex items-center justify-center rounded-lg bg-brand-500/5 p-3 font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/10`}
                  >
                    {x.description}
                  </button>
                ))}
              </div>
              <div className="mt-auto flex flex-col">
                <div className="flex flex-row justify-end">
                  <button
                    onClick={() => {
                      setSubTreatPlan([]);
                      setTreatPlanId("");
                    }}
                    style={{ fontSize: modalTextFontSize }}
                    className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Remark Sections ── */}
      {page === 2 && (
        <div className="flex flex-col border-t border-shadowSecondary bg-surfacePrimary pt-2">
          <div className="flex flex-row items-center">
            <div className="flex" style={{ width: "80%" }}>
              <label
                className="mt-2 font-medium text-textSecondary"
                style={{ paddingRight: "1%" }}
              >
                Remarks
              </label>
              <input
                style={{ marginRight: "1%" }}
                type="text"
                value={complaintRemark}
                onChange={(e) => setComplaintRemark && setComplaintRemark(e.target.value)}
                placeholder="Remarks for complaints"
                className="w-full rounded border border-shadowSecondary bg-surfacePrimary p-2 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
              />
            </div>
            <div className="flex justify-end gap-2" style={{ width: "30%" }}>
              <div className="flex-1">
                <button
                  onClick={() => setLocationDialog(true)}
                  className="linear flex w-full items-center justify-center rounded-lg !bg-surfaceSecondary p-3 text-sm font-bold !text-textPrimary text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
                >
                  Location <LiaSearchLocationSolid className="ml-1" />
                </button>
              </div>
              <div className="flex-1">
                <button
                  onClick={() => setDurationDialog(true)}
                  className="linear flex w-full items-center justify-center rounded-lg !bg-brand-50 p-3 text-sm font-bold !text-brand-700 text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-50/80 active:bg-brand-50/70"
                >
                  Duration <MdAlarm className="ml-1" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 3 && (
        <div className="flex flex-col border-t border-shadowSecondary bg-surfacePrimary pt-2">
          <div className="flex flex-row items-center">
            <div className="flex" style={{ width: "80%" }}>
              <label
                className="mt-2 font-medium text-textSecondary"
                style={{ paddingRight: "1%" }}
              >
                Remarks
              </label>
              <input
                style={{ marginRight: "1%" }}
                type="text"
                value={otherSymptomRemark}
                onChange={(e) => setOtherSymptomRemark(e.target.value)}
                placeholder="Remarks for other symptoms"
                className="w-full rounded border border-shadowSecondary bg-surfacePrimary p-2 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
              />
            </div>
            <div className="flex justify-end gap-2" style={{ width: "30%" }}>
              <div className="flex-1">
                <button
                  onClick={() => setOtherSymptomLocationDialog(true)}
                  className="linear flex w-full items-center justify-center rounded-lg !bg-surfaceSecondary p-3 text-sm font-bold !text-textPrimary text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
                >
                  Location <LiaSearchLocationSolid className="ml-1" />
                </button>
              </div>
              <div className="flex-1">
                <button
                  onClick={() => setOtherSymptomDurationDialog(true)}
                  className="linear flex w-full items-center justify-center rounded-lg !bg-brand-50 p-3 text-sm font-bold !text-brand-700 text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-50/80 active:bg-brand-50/70"
                >
                  Duration <MdAlarm className="ml-1" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {page === 4 && (
        <div className="flex flex-col border-t border-shadowSecondary bg-surfacePrimary pt-2">
          <div className="flex flex-row items-center">
            <div className="flex" style={{ width: "80%" }}>
              <label
                className="mt-2 font-medium text-textSecondary"
                style={{ paddingRight: "1%" }}
              >
                Remarks
              </label>
              <input
                style={{ marginRight: "1%" }}
                type="text"
                value={historyRemark}
                onChange={(e) => setHistoryRemark(e.target.value)}
                placeholder="Remarks for History"
                className="w-full rounded border border-shadowSecondary bg-surfacePrimary p-2 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
              />
            </div>
            <div className="flex justify-end" style={{ width: "20%" }}>
              <button
                onClick={() => setHistoryDurationDialog(true)}
                className="linear flex w-full items-center justify-center rounded-lg !bg-brand-50 p-3 text-sm font-bold !text-brand-700 text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-50/80 active:bg-brand-50/70"
              >
                Duration <MdAlarm className="ml-1" />
              </button>
            </div>
          </div>
        </div>
      )}

      {page === 5 && (
        <div className="flex flex-col border-t border-shadowSecondary bg-surfacePrimary pt-2">
          <div className="flex flex-row items-center">
            <div className="flex" style={{ width: "80%" }}>
              <label
                className="mt-2 font-medium text-textSecondary"
                style={{ paddingRight: "1%" }}
              >
                Remarks
              </label>
              <input
                style={{ marginRight: "1%" }}
                type="text"
                value={examinationRemark}
                onChange={(e) => setExaminationRemark(e.target.value)}
                placeholder="Remarks for Examination"
                className="w-full rounded border border-shadowSecondary bg-surfacePrimary p-2 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
              />
            </div>
            <div className="flex justify-end" style={{ width: "20%" }}>
              <button
                onClick={() => setExaminationLocationDialog(true)}
                className="linear flex w-full items-center justify-center rounded-lg !bg-surfaceSecondary p-3 text-sm font-bold !text-textPrimary text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
              >
                Location <LiaSearchLocationSolid className="ml-1" />
              </button>
            </div>
          </div>
        </div>
      )}

      {page === 6 && (
        <div className="flex flex-col border-t border-shadowSecondary bg-surfacePrimary pt-2">
          <div className="flex flex-row items-center">
            <div className="flex" style={{ width: "80%" }}>
              <label
                className="mt-2 font-medium text-textSecondary"
                style={{ paddingRight: "1%" }}
              >
                Remarks
              </label>
              <input
                style={{ marginRight: "1%" }}
                type="text"
                value={impressionRemark}
                onChange={(e) => setImpressionRemark(e.target.value)}
                placeholder="Remarks for Assessment"
                className="w-full rounded border border-shadowSecondary bg-surfacePrimary p-2 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
              />
            </div>
            <div className="flex justify-end" style={{ width: "20%" }}>
              <button
                onClick={() => setImpressionLocationDialog(true)}
                className="linear flex w-full items-center justify-center rounded-lg !bg-surfaceSecondary p-3 text-sm font-bold !text-textPrimary text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
              >
                Location <LiaSearchLocationSolid className="ml-1" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Navigation + optional Remarks ── */}
      <div className="flex shrink-0 items-center justify-end gap-2 border-t mt-2 border-shadowSecondary pt-2">
        {page === 7 && (
          <>
            <label className="shrink-0 font-medium text-textSecondary">
              Remarks
            </label>
            <input
              type="text"
              value={treatmentRemark}
              onChange={(e) => setTreatmentRemark(e.target.value)}
              placeholder="Remarks for Plan"
              className="min-w-0 flex-1 rounded border border-shadowSecondary bg-surfacePrimary p-2 text-textPrimary outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
            />
          </>
        )}
        <button
          onClick={handlePrevious}
          className="linear shrink-0 flex w-20 items-center justify-center rounded-lg bg-surfaceSecondary p-3 text-sm font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
        >
          Previous
        </button>
        {currentIteration &&
          currentIteration.iterationName === "Systems" &&
          currentIteration.iterationState && (
            <button
              disabled={selectedOptionList && selectedOptionList.length <= 0}
              onClick={handleNext}
              className={`linear shrink-0 flex w-20 items-center justify-center rounded-lg !bg-brand-500 bg-surfaceSecondary p-3 text-sm font-bold !text-white text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-brand-500/80 active:bg-brand-500/70 ${selectedOptionList && selectedOptionList.length <= 0
                ? "!opacity-60"
                : ""
                }`}
            >
              Next
            </button>
          )}
      </div>

      {/* ── Vitals Modal ── */}
      {isVitalsOpened && (
        <div className="bg-black/40 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="relative mx-4 w-full max-w-5xl flex max-h-[90vh] flex-col rounded-2xl bg-surfacePrimary p-8 shadow-xl dark:bg-navy-800">
            <button
              className="absolute right-4 top-3 text-2xl font-bold text-textSecondary hover:text-textPrimary dark:text-gray-300"
              onClick={() => setIsVitalsOpened(false)}
            >
              &times;
            </button>
            <div className="flex max-h-full flex-col gap-4 overflow-hidden">
              <h2
                style={{ fontSize: modalTitleFontSize }}
                className="shrink-0 font-semibold text-textPrimary"
              >
                Vitals
              </h2>
              <div className="no-scrollbar mb-2 w-full flex-1 overflow-y-auto overflow-x-hidden">
                <Grid container spacing={1} alignItems="stretch">
                  {defaultBtn.map((e, i) => {
                    const isInData = data.some((item) => item.description === e.desc);
                    return (
                      <Grid
                        key={i}
                        item
                        xs={12}
                        sm={6}
                        md={gridMd as any}
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <Box
                          onClick={() => handleButtonClick(i)}
                          sx={{ flex: 1, display: "flex", flexDirection: "column" }}
                        >
                          <DefaultBtnModel
                            desc={e.desc}
                            data={data}
                            isSelected={selectedButton === i}
                            onSubmit={onSubmitClick}
                            onRemove={onRemoveClick}
                            isInData={isInData}
                            textSize={textSize}
                          />
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </div>
              <div className="flex shrink-0 justify-end">
                <button
                  onClick={() => setIsVitalsOpened(false)}
                  style={{ fontSize: modalTextFontSize }}
                  className="rounded-lg bg-brand-500 px-6 py-3 font-semibold text-white transition duration-200 hover:bg-brand-500/80 active:bg-brand-500/70"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AppSnackbar
        isOpen={snackbar.open}
        title={snackbar.message}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        severity={snackbar.severity}
      />
        </>
      )}
    </div>
  );
};

export default WizardManagement;
